module.exports = __webpack_public_path__ + "img/yishi2.91a9d7dd.jpg";